import { ECustomDesignTypes, ThemePack } from '@/types/theme-packs.types';
import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';
import RangeInput from '@ui/range-input/range-input';
import Container from '@ui/container/container';
import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';
import Text from '@ui/text/text/text';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';

type TCornerCardProps = {
  type: ECustomDesignTypes;
  onChange: (value: number) => void;
  value: number;
  themePack: ThemePack;
};

const InputLabels = {
  [ECustomDesignTypes.input]: 'Inputs',
  [ECustomDesignTypes.button]: 'Buttons',
  [ECustomDesignTypes.container]: 'Containers',
  [ECustomDesignTypes.img]: 'Images',
  [ECustomDesignTypes.label]: 'Labels',
};

const InputTooltips = {
  [ECustomDesignTypes.input]: 'Field where text is entered',
  [ECustomDesignTypes.button]: 'Important actions or triggers',
  [ECustomDesignTypes.container]: 'Interactive components',
  [ECustomDesignTypes.img]: 'Photos or video stills',
  [ECustomDesignTypes.label]: 'Descriptive elements',
};

export default function CornerCard({ type, onChange, value }: TCornerCardProps) {
  return (
    <Container
      background="var(--gray-800)"
      borderRadius="12px"
      padding="16px"
      width="228px"
      height="64px"
      className="flex gap-8 ai-center"
    >
      <label className="S2 flex-1 ws-nowrap">
        {InputLabels[type]}
        <TooltipPortal
          portalWrapperStyles={{ display: 'inline-block', width: 12, position: 'relative', top: 2, left: 4 }}
          tooltipContent={<Text color="var(--gray-true-dark-100)">{InputTooltips[type]}</Text>}
        >
          <Icon name={ICONS.INFO_CIRCLE} color="var(--gray-600)" size={12} />
        </TooltipPortal>
      </label>

      <RangeInput onChange={onChange} value={value} min={0} max={100} />
      <InputWithOverlay
        inputHeight="28px"
        border="1px solid var(--gray-600)"
        inputProps={{
          value,
          type: 'number',
          onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
            onChange(e.target.valueAsNumber);
          },
          style: {
            textAlign: 'center',
            width: 60,
            fontSize: 12,
            fontWeight: 500,
            color: 'var(--gray-200)',
          },
        }}
      />
    </Container>
  );
}
